module.exports = __webpack_public_path__ + "static/media/pill.dc94d8cc.svg";